import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import CardMaster from 'components/Product/CardMaster';
import Typography from '@mui/material/Typography';
import { CGProduct } from 'types/shopify';
import { useHistory } from 'react-router-dom';

interface NoResultDisplayProps {
  searchQuery: string;
  hasDivider?: boolean;
  source?: 'quickSearch' | 'fullSearch';
  alternative?: CGProduct;
  onClose?: () => void;
}
const NoResultDisplay: React.FC<NoResultDisplayProps> = ({ searchQuery, hasDivider = true, source, alternative, onClose }) => {
  const history = useHistory();

  const onClick = () => {
    alternative && history.push(`/product/${alternative.handle}`);
    onClose && onClose();
  };

  return (
    <Stack
      sx={{
        pt: { xs: 3, md: source === 'fullSearch' ? 0 : 11 },
        pb: { md: 18 },
        px: { md: 3.5 },
        color: 'text.secondary',
      }}
      spacing={4}
    >
      <Stack alignItems="center" spacing={2} sx={{ mb: { md: source === 'fullSearch' ? 0 : 10 } }}>
        <Stack direction="row" justifyContent="center">
          <Typography variant="h3"> No results for&nbsp;</Typography>
          <Typography variant="h3" sx={{ color: 'secondary.main' }}>
            {searchQuery}
          </Typography>
        </Stack>
        <Box sx={{ typography: 'subtitle1', color: 'text.secondary', textAlign: 'center' }}>Please check your spelling or try different keywords</Box>
      </Stack>
      {hasDivider && <Divider sx={{ mt: 10 }} />}
      <Stack alignItems="center" spacing={4}>
        <Box sx={{ typography: 'subtitle1', maxWidth: source === 'quickSearch' ? 400 : 450, textAlign: 'center' }}>
          Otherwise, consider the Card.Gift choice card. This gives access to any one of our hundreds of retailers
        </Box>
      </Stack>
      {source === 'quickSearch' && (
        <Stack direction="row">
          <Stack sx={{ width: { xs: '30%', md: '150px' } }}>
            <CardMaster
              size="medium"
              // @ts-ignore
              item={alternative}
            />
          </Stack>
          <Stack sx={{ width: { xs: '70%' }, pl: { xs: 2, md: 5 }, cursor: 'pointer' }} onClick={onClick}>
            <Typography variant="h3" sx={{ color: 'primary.main', mb: { xs: 0, md: 1 } }}>
              Card.Gift Choice Card
            </Typography>
            <Typography sx={{ width: { xs: '100%', md: '80%' }, fontSize: { xs: '14px', md: '16px' } }}>
              The Card.Gift choice card turns into one or more gift cards from the 150+ top brands
            </Typography>
          </Stack>
        </Stack>
      )}
      {source === 'fullSearch' && (
        <Stack mt={8}>
          <Divider />
          <Typography sx={{ color: 'primary.main', mt: 6, mb: 3 }}>View gift cards</Typography>
          <Stack
            sx={{
              height: {
                xs: '110px',
                sm: '195px',
              },
              width: {
                xs: '170px',
                sm: '300px',
              },
            }}
          >
            <CardMaster
              size="medium"
              // @ts-ignore
              item={alternative}
              sx={{
                backgroundSize: 'contain !important',
                marginLeft: -1,
              }}
            />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default NoResultDisplay;
